import React, { useContext, forwardRef } from 'react'
import { Select, MenuItem, InputLabel, FormControl, TextField, Autocomplete } from '@mui/material'
import { LoadingContext } from '../M_Utils'

export const M_Select = forwardRef(({ label, value, options, color, secondColor, disabled,
    required, onChange, onClick, multiple, minWidth, itemTemplate, height,
    margin, padding, fontSize, marginLeft, marginRight, size, autocomplete,
    onChangeValue, noNone }, ref) => {
    const ctx = useContext(LoadingContext)

    color = color || ctx.primaryColor || 'var(--color-black)'
    secondColor = secondColor || ctx.secondaryColor || 'var(--color-black)'

    const styles = {
        margin: margin,
        width: size || null,
        marginLeft: marginLeft,
        marginRight: marginRight,
        '& label': { color: 'var(--color-black)', fontWeight: 'bold' },
        '& label.Mui-focused': { color: 'var(--color-black)' },
        '& .MuiInput-underline:after': { borderBottomColor: color },
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: 'rgba(0, 0, 0, 0.38) !important'
            }
        },
        '& .MuiOutlinedInput-input': {
            backgroundColor: 'var(--color-white)',
            padding: padding,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: color,
                width: size || 'auto',
                height: height,
            },
            '&:hover fieldset': {
                borderColor: color,
            },
            '&.Mui-focused fieldset': {
                borderColor: color,
                boxShadow: `2px 2px 2px ${color}`
            }
        },
    }

    const normalizedSelectValue = multiple
        ? (Array.isArray(value) ? value : [])
        : (value ?? '')

    return (
        <>
            {autocomplete ?
                <Autocomplete
                    id="combo-box-demo"
                    options={options}
                    sx={styles}
                    getOptionLabel={(e) => {
                        return e?.label || ''
                    }}
                    multiple={multiple}
                    value={value}
                    disabled={disabled}
                    onChange={(event, value, reason) => onChangeValue(value)}
                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        required={required}
                        label={label}
                        variant="outlined"
                        style={{ height: height, textOverflow: 'ellipsis' }}
                        sx={styles}
                        size="small"
                        id="margin-none"
                        disabled={disabled}
                    />}
                    ListboxProps={{ style: { maxHeight: 196 } }}
                />
                :
                <FormControl
                    sx={{
                        margin: margin,
                        '& label': { color: 'var(--color-black)', fontWeight: 'bold' },
                        '& label.Mui-focused': { color: 'var(--color-black)' },
                        '& .MuiInput-underline:after': { color: color, borderColor: "transparent" },
                        "& .MuiInputBase-root.Mui-disabled": {
                            "& > fieldset": {
                                borderColor: 'rgba(0, 0, 0, 0.38) !important'
                            }
                        },
                        '& .MuiOutlinedInput-root': {
                            height: height,
                            fontSize: fontSize,
                            padding: padding,
                            '& fieldset': {
                                borderColor: 'rgba(0, 0, 0, 0.38) !important',
                            },
                            '&:hover fieldset': {
                                borderColor: 'rgba(0, 0, 0, 0.38) !important',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: color,
                                boxShadow: `2px 2px 2px rgba(0, 0, 0, 0.38) !important`
                            },
                        },
                        minWidth: minWidth,
                    }}
                    margin="dense"
                    fullWidth
                    size='small'
                    required={required}
                    id="margin-none"
                    disabled={disabled}
                >
                    <InputLabel shrink>{label}</InputLabel>
                    <Select notched={true} label={label} value={normalizedSelectValue} disabled={disabled} required={required} onChange={onChange} multiple={multiple}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 155,
                                    "& .Mui-selected": {
                                        backgroundColor: "var(--color-grey-light)",
                                        height: height
                                    },
                                    "& .Mui-selected:hover": {
                                        backgroundColor: "var(--color-grey-light)"
                                    },
                                }
                            }
                        }}
                    >
                        {!noNone && <MenuItem value="" onClick={() => onClick ? onClick({}) : {}}  > <em>None</em> </MenuItem>}
                        {options.map((el, index) => (
                            <MenuItem key={index} disableRipple={true} value={el.value} onClick={() => onClick ? onClick(el) : {}}  > {itemTemplate ? itemTemplate(el) : el.label} </MenuItem>
                        ))}
                    </Select>
                </FormControl>}
        </>
    )
})
